import { FormValues } from '../types';

const transformMarketingPreferences = (userData: FormValues) => {
    const preferences = [
        {
            user_preference_group_id: 2,
            type_id: 0,
            variant_id: 0,
            opt_in: userData.opt_in_text == '1',
            delivery: {
                text: userData.opt_in_text == '1',
            },
        },
        {
            user_preference_group_id: 3,
            type_id: 0,
            variant_id: 0,
            opt_in: userData.opt_in_email == '1',
            delivery: {
                email: userData.opt_in_email == '1',
                text: userData.opt_in_text == '1',
            },
        },
    ];

    delete userData.opt_in_email;
    delete userData.opt_in_text;

    userData.preferences = preferences;
};

export default transformMarketingPreferences;